import { m8API } from 'services/production/m8';
import { GetPartnerClientNotesService } from 'types/services';
import { UserNotFoundError } from 'utils/errors';

export const getPartnerClientNotes: GetPartnerClientNotesService = async (
  clientId
) => {
  const value = await m8API.partner
    .getClientComment({
      idClient: clientId,
    })
    .then((rawValue) => {
      return rawValue || '';
    })
    .catch((error) => {
      if (error instanceof UserNotFoundError) {
        return null;
      }

      throw error;
    });

  return value;
};
